export default [
    '#1e78b4',
    '#194d72',
    '#b1d954',
    '#5B7537',
    '#FFA500',
    '#4682B4',
    '#EEE8AA',
    // '#8B008B',
    '#7B68EE',
    '#40E0D0',
    '#FFD700',
    // 'blue', 'green', 'red', 'yellow', 'black'
];

export const getRandomColor = () => {
    const colors = [
        '#1e78b4',
        '#194d72',
        '#b1d954',
        '#5B7537',
        '#FFA500',
        '#4682B4',
        '#EEE8AA',
        '#8B008B',
        '#7B68EE',
        '#40E0D0',
        '#FFD700',
        '#FF6347',
        '#FF4500',
        '#32CD32',
        '#00CED1',
        '#8A2BE2',
        '#FF69B4',
        '#FF1493',
        '#00BFFF',
        '#1E90FF',
        '#7FFF00',
        '#FF8C00',
        '#D2691E',
        '#ADFF2F',
        '#FF00FF',
        '#00FF7F',
        '#FFB6C1',
        '#B22222',
        '#8B4513',
        '#2E8B57',
        '#6A5ACD',
        '#FF4500',
        '#FF6347',
    ];

    return colors[Math.floor(Math.random() * colors.length)];
}

export const polosGeradoresColor = {
    'Alimentação': [255, 117, 31],       // Laranja
    'Automotivo': [31, 95, 138],         // Azul escuro
    'Decoração': [255, 213, 0],         // amarelo
    'Educação': [0, 139, 192],           // azul claro
    'Instituição Financeira': [100, 170, 48],        // verde claro
    'Saúde e Bem-Estar': [91, 117, 55],              // verde
    'Moda': [232, 69, 169],              // rosa
    'Outros': [115, 115, 115],             // cinza
    'Loja De Materiais De Construção': [98, 68, 24], // marrom
    'Shopping Center': [216, 26, 26],    // vermelho
    'Serviços': [191, 150, 0],           // amarelo escuro
};


